import { render, staticRenderFns } from "./virtualCode.vue?vue&type=template&id=6b5bc18e&scoped=true&"
import script from "./virtualCode.vue?vue&type=script&lang=js&"
export * from "./virtualCode.vue?vue&type=script&lang=js&"
import style0 from "./virtualCode.vue?vue&type=style&index=0&id=6b5bc18e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5bc18e",
  null
  
)

export default component.exports